import React, { Component } from 'react';

class LatestNewsSection extends Component{
	render(){
		
		return(
			<>
				
				<section className="section-sp1 service-wraper2">
					<div className="container">
						<div className="row">
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">xxxx</h2>
									<h5 className="ttr-title">XXXXXX</h5>
									<p>XXXXXXXXXXXXXXXX</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">XXXXX</h2>
									<h5 className="ttr-title">XXXXXX</h5>
									<p>XXXXXXXXX</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">XXXXX</h2>
									<h5 className="ttr-title">XXXXXX</h5>
									<p>XXXXXXX</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">XXXX</h2>
									<h5 className="ttr-title">XXXXXXX</h5>
									<p>XXXXXXX</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				
			</>
		);
	}
}

export default LatestNewsSection;